var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"form-item",class:{'border-bottom' : _vm.disableBorder }},[_c('p',{staticClass:"title",style:({color:_vm.titleColor})},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('section',{staticClass:"form-item-content"},[_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.subTitle)}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }